import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TidyStorage {

  private readonly expiredKeys = ['me'];
  
  constructor(
    private router: Router,
    private storage: Storage
  ) {
    this.storage.create();
  }

  save(key: string, value: any, expiresAt: number | null = null): Promise<void> {
    if (expiresAt) {
      const expiresAtKey = `${key}-expires-at`;
      this.storage?.set(expiresAtKey, expiresAt);
    }
    return this.storage?.set(key, value);
  }

  async retrieve(key: string): Promise<any> {
    await this.isExpiredCheck(key);
    return await this.storage?.get(key);
  }

  async isExpiredCheck(key: string): Promise<void> {
    const expiresAt = await this.storage?.get(`${key}-expires-at`);
    if (expiresAt) {
      const now = Date.now();
      if (now > expiresAt) {
        await this.storage?.remove(key);
        await this.storage?.remove(`${key}-expires-at`);
        return;
      }
      return;
    }
    // Force expire if expires-at was never set
    if (this.expiredKeys.includes(key)) {
      await this.storage?.remove(key);
    }
  }

  delete(key: string): any {
    return this.storage?.remove(key);
  }

  async clear() {
    await this.storage?.clear();
    const themeMode = localStorage.getItem('tidy_theme_mode');
    const themeUserSet = localStorage.getItem('tidy_theme_user_set');
    localStorage.clear();
    if (themeMode) {
      localStorage.setItem('tidy_theme_mode', themeMode);
    }
    if (themeUserSet) {
      localStorage.setItem('tidy_theme_user_set', themeUserSet);
    }
  }

  setStoredRoute(route: string): Promise<boolean> {
    return new Promise((resolve) => {
      const subscription = this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects.includes(route)) {
          subscription.unsubscribe();
          resolve(true);
        }
      });
    });
  }

}
